import { Stack } from "@mui/material"
import { ReactElement, useContext } from "react"

import InstallerApplicationBasicFormBuilder from "./basicForm/installerApplicationBasicFormBuilder"
import RecognisedFormGenerator from "./recongisedForms/recognisedFormGenerator"
import SingleArrayFormGenerator from "./singleArrayForm/singleArrayFormGenerator"
import {
    IPossibleApplicationForms,
    isSingleArrayForm,
    isRecognisedForm,
} from "../../../../services/middleware/types/singleApplication/getSchemaTypes"
import { GRID_SPACING } from "../../../../themes/defaultThemeParams"
import FormHeader from "../../../formHeader/formHeader"
import { ApplicationContext } from "../applicationProvider"

export const APPLICATION_SPACING = GRID_SPACING + 1

interface FormDispatcherProps {
    formKey: string
    displayTitle: string
    displaySubtitle: string
    formProperties: IPossibleApplicationForms
}

/**
 * Renders a form based on the formProperties. If the formProperties are of
 * type ISingleArrayFormSpec, then a pre-recognised form is rendered. Otherwise,
 * a basic form is rendered.
 */
const FormDispatcher = ({
    formKey,
    displayTitle,
    displaySubtitle,
    formProperties,
}: FormDispatcherProps): ReactElement => {
    const { currentStepIndex, setCurrentStepIndex, isFirstStep, stepLabels } =
        useContext(ApplicationContext)

    const selectForm = (): ReactElement => {
        if (isRecognisedForm(formProperties)) {
            return (
                <RecognisedFormGenerator
                    formKey={formKey}
                    formProperties={formProperties}
                />
            )
        }
        if (isSingleArrayForm(formProperties)) {
            return (
                <SingleArrayFormGenerator
                    formKey={formKey}
                    formProperties={formProperties}
                />
            )
        }
        return (
            <InstallerApplicationBasicFormBuilder
                formKey={formKey}
                formProperties={formProperties}
            />
        )
    }
    return (
        <Stack spacing={APPLICATION_SPACING}>
            <FormHeader
                header={displayTitle}
                subHeader={displaySubtitle}
                index={currentStepIndex + 1}
            />
            {selectForm()}
        </Stack>
    )
}

export default FormDispatcher
